
import { computed, defineComponent, ref } from 'vue';
import { useRoute } from 'vue-router';

    function bespokeComposition () {
		/**
		 * Endpoint
		 */
		const route = useRoute();
		const endpointId = computed((): string => {
			return route.params.endpointId as string;
		});

        /**
         * Popups
         */
        const popups = ref<any[]>([
            {
                continent: 'europe',
                open: false
            },
            {
                continent: 'asia',
                open: false
            },
            {
                continent: 'americas',
                open: false
            },
            {
                continent: 'oceania',
                open: false
            },
            {
                continent: 'africa',
                open: false
            },
        ]);

        function activePopup (popup: string): void {
            const currentPopup = popups.value.find((_: any) => _.continent === popup);
            
            currentPopup.open = !currentPopup.open;
        }

		return { endpointId, popups, activePopup }
	}

    export default defineComponent({
        setup() {
            return { ...bespokeComposition() }
        },
    })
